import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { OrganizationCapabilities, OrganizationSettings } from '@paragon/contract-library';

/** measured placement of the floating checked-rows action bar */
export interface CheckedRowsActionBarRect {
  readonly left: number;
  readonly height: number;
}

export interface ApplicationState {
  readonly allDataLoaded: boolean;
  readonly organizationSettings: OrganizationSettings | null;
  readonly organizationCapabilities: OrganizationCapabilities | null;

  /** measured right edge of the snackbar stack */
  readonly snackbarStackRight: number | null;

  /** measured action bar placement, or null while the bar is hidden */
  readonly checkedRowsActionBarRect: CheckedRowsActionBarRect | null;
}

const initialState: ApplicationState = {
  allDataLoaded: false,
  organizationSettings: null,
  organizationCapabilities: null,
  snackbarStackRight: null,
  checkedRowsActionBarRect: null,
};

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  reducers: {
    applicationFullyLoaded: (state) => {
      state.allDataLoaded = true;
    },
    organizationSettingsSet: (state, action: PayloadAction<OrganizationSettings>) => {
      state.organizationSettings = action.payload;
    },
    organizationCapabilitiesSet: (state, action: PayloadAction<OrganizationCapabilities>) => {
      state.organizationCapabilities = action.payload;
    },
    snackbarStackRightSet: (state, action: PayloadAction<number>) => {
      state.snackbarStackRight = action.payload;
    },
    actionBarRectSet: (state, action: PayloadAction<CheckedRowsActionBarRect | null>) => {
      state.checkedRowsActionBarRect = action.payload;
    },
  },
});

export const {
  applicationFullyLoaded,
  organizationSettingsSet,
  organizationCapabilitiesSet,
  snackbarStackRightSet,
  actionBarRectSet,
} = applicationSlice.actions;
export const application = applicationSlice.reducer;
